{/* Auto-generated icon - do not edit */}
import React from 'react'

interface PencilIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const PencilIcon = React.forwardRef<SVGSVGElement, PencilIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 151 143"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M0.829281 137.349C0.907504 136.776 1.01489 136.207 1.15105 135.645C3.18196 128.464 5.27638 121.3 7.23822 114.1C7.42208 113.269 7.77498 112.486 8.27484 111.799C8.77469 111.111 9.41067 110.535 10.143 110.106C10.8728 109.673 11.5443 109.149 12.1409 108.545C35.4936 84.8023 60.3992 62.7284 84.9502 40.2711C95.2535 30.8463 105.194 21.0228 115.461 11.5562C119.359 7.96168 123.653 4.78592 127.878 1.56652C130.164 -0.176752 131.535 -0.177334 133.655 1.57779C138.581 5.65416 143.476 9.77985 148.202 14.0853C151.281 16.8902 151.33 19.9691 148.419 22.9701C144.267 27.2493 139.909 31.3275 135.638 35.4919C135.181 35.9382 134.705 36.3657 134.269 36.837C118.794 53.6655 101.877 69.0055 85.0927 84.4665C73.018 95.5908 60.5237 106.26 48.2623 117.184C44.76 120.304 41.3915 123.576 38.0038 126.822C33.1115 131.595 27.1282 135.095 20.5764 137.015C15.5729 138.473 10.6447 140.198 5.61685 141.559C2.42328 142.428 0.648161 140.767 0.829281 137.349ZM117.043 19.8088C114.932 21.5596 112.916 23.1249 111.018 24.8226C87.807 45.5775 64.6018 66.3391 41.4021 87.1073C33.5449 94.1596 26.1194 101.681 19.166 109.631C18.2797 110.639 17.4805 111.724 16.5855 112.844L20.0884 116.657C55.3166 86.558 88.3218 54.2416 124.022 24.1629L117.043 19.8088ZM28.194 125.813C43.7897 114.724 123.904 39.9359 130.393 30.3888L127.966 27.5178C127.103 28.1912 126.41 28.6724 125.781 29.231C104.689 48.0306 83.5466 66.7741 62.5372 85.6674C50.0131 96.9303 37.8394 108.591 24.4396 118.839C23.9465 119.165 23.4338 119.46 22.9042 119.722L28.194 125.813ZM122.666 13.6982L135.363 25.4899L143.018 18.9294L131.142 7.25126L122.666 13.6982ZM11.0778 118.152C10.4337 120.938 9.91208 122.886 9.56602 124.865C9.45629 125.577 9.59527 126.304 9.95938 126.925C11.1115 128.699 12.4154 130.374 13.7642 132.23L20.1843 129.707L11.0778 118.152Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="150" height="142.308" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

PencilIcon.displayName = 'PencilIcon'
